// extracted by mini-css-extract-plugin
export default {"Box":"InsightsFilterBar-module__Box--JES0c"};